import React, { useState, useEffect, useRef } from "react";
import { Button, Box, Typography, Grid } from "@mui/material";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import { GameModes } from "../../data/gameModes";

const GameScreen = ({
  currentGameMode,
  currentQuestionIndex,
  currentScore,
  questionsAnswered,
  gameQuestions,
  timeRemaining,
  timerActive,
  selectAnswer,
  nextQuestion,
  currentQuestionData,
  speakWord,
  goBack,
}) => {
  const isInitialQuestion = useRef(true);

  useEffect(() => {
    if (currentQuestionData) {
      if (currentQuestionData.replayAudioWord) {
        if (isInitialQuestion.current) {
          speakWord(currentQuestionData.replayAudioWord);
          isInitialQuestion.current = false;
        } else if (currentQuestionIndex > 0) {
          speakWord(currentQuestionData.replayAudioWord);
        }
      }
    }
  }, [currentQuestionIndex, currentQuestionData, speakWord]);

  if (!currentQuestionData) return null;

  const {
    question,
    questionText,
    questionEmoji,
    replayAudioWord,
    options,
    correctIndex,
    questionGameMode,
  } = currentQuestionData;

  const handleSelectAnswer = (selectedOption) => {
    selectAnswer(
      selectedOption,
      options[correctIndex],
      options,
      questionGameMode
    );
  };

  return (
    <Box id="gameMode" className="screen" sx={{ p: 2 }}>
      <Box
        className="game-header"
        sx={{ display: "flex", justifyContent: "space-between", mb: 2 }}
      >
        {currentGameMode === "TIME_CHALLENGE" ? (
          <Typography variant="h6" id="timerDisplay">
            時間: <span id="timeRemaining">{timeRemaining}</span>秒
          </Typography>
        ) : null}
        <Typography variant="h6" className="score-display">
          得分: <span id="scoreDisplay">{currentScore}</span>
          {currentGameMode !== GameModes.TIME_CHALLENGE.name ? "/10" : ""}
        </Typography>
        <Typography variant="h6" className="question-number">
          {currentGameMode === GameModes.TIME_CHALLENGE.name ? (
            <span id="questionNumber">{currentQuestionIndex + 1}</span>
          ) : (
            <span id="questionNumber">{currentQuestionIndex + 1}/10</span>
          )}
        </Typography>
      </Box>

      <Box className="question-container" sx={{ my: 3, textAlign: "center" }}>
        {questionEmoji && (
          <Typography
            variant="h2"
            id="questionEmoji"
            className="question-emoji"
          >
            {questionEmoji}
          </Typography>
        )}
        {replayAudioWord ? (
          <Button
            variant="outlined"
            startIcon={<VolumeUpIcon />}
            id="replayAudioBtn"
            onClick={() => speakWord(replayAudioWord)}
          >
            重播聲音
          </Button>
        ) : questionText ? (
          <Typography variant="h5" id="questionText" className="question-text">
            {questionText}
          </Typography>
        ) : null}
      </Box>

      <Box
        id="optionsContainer"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          mb: 3,
          width: "100%",
          gap: "16px", // Small consistent gap
        }}
      >
        {options.map((opt, idx) => (
          <Box key={idx} sx={{ flexGrow: 1 }}>
            <Button
              variant="contained"
              fullWidth
              onClick={() => handleSelectAnswer(opt)}
              disabled={questionsAnswered}
              color={
                questionsAnswered
                  ? idx === correctIndex
                    ? "success"
                    : opt === options[correctIndex]
                    ? "primary"
                    : "error"
                  : "primary"
              }
              sx={{ height: "100%" }}
            >
              {questionGameMode === 1 || questionGameMode === 5
                ? opt.chinese
                : opt.english}
            </Button>
          </Box>
        ))}
      </Box>

      <Button variant="outlined" onClick={goBack}>
        返回主目錄
      </Button>
    </Box>
  );
};

export default GameScreen;
